import { render, staticRenderFns } from "./AgendaVideos.vue?vue&type=template&id=1ce493a1&scoped=true"
import script from "./AgendaVideos.vue?vue&type=script&lang=js"
export * from "./AgendaVideos.vue?vue&type=script&lang=js"
import style0 from "./AgendaVideos.vue?vue&type=style&index=0&id=1ce493a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce493a1",
  null
  
)

export default component.exports